import { Link } from "react-router";
import { Building2, CalendarDays, ChevronRight, FileScan, Smile, Wrench, type LucideIcon } from "lucide-react";
import { trpc } from "@/lib/trpc";

type Numero = { rotulo: string; valor?: number; icone: LucideIcon; cor: string; para?: string };

/** Os números da pessoa, somados entre as organizações dela (ver `me.resumo`). */
export function NumerosDoPerfil() {
  const resumo = trpc.me.resumo.useQuery().data;
  const numeros: Numero[] = [
    { rotulo: "Organizações", valor: resumo?.organizacoes, icone: Building2, cor: "#2457ff", para: "/conta/organizacoes" },
    { rotulo: "Pacientes", valor: resumo?.pacientes, icone: Smile, cor: "#10b981", para: "/pacientes" },
    { rotulo: "Atendimentos no mês", valor: resumo?.atendimentosNoMes, icone: CalendarDays, cor: "#6366f1", para: "/agenda" },
    // Ainda não há tela de exames — o cartão só mostra o número.
    { rotulo: "Exames", valor: resumo?.exames, icone: FileScan, cor: "#f59e0b" },
    { rotulo: "Trabalhos solicitados", valor: resumo?.trabalhosSolicitados, icone: Wrench, cor: "#f43f5e", para: "/protese" },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {numeros.map(({ rotulo, valor, icone: Icone, cor, para }) => {
        const corpo = (
          <>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg sm:h-11 sm:w-11" style={{ backgroundColor: `${cor}1a`, color: cor }}>
              <Icone className="h-5 w-5" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-xl font-bold tabular-nums text-zinc-900 sm:text-2xl dark:text-foreground">{valor ?? "–"}</span>
              <span className="block text-xs leading-tight text-zinc-500 dark:text-muted-foreground">{rotulo}</span>
            </span>
            {para && <ChevronRight className="hidden h-4 w-4 shrink-0 text-zinc-300 sm:block" />}
          </>
        );
        const classe = "flex items-center gap-3 rounded-xl border border-zinc-200 bg-white p-3 shadow-sm sm:p-4 dark:border-border dark:bg-card";
        return para ? (
          <Link key={rotulo} to={para} className={`${classe} transition-colors hover:border-zinc-300`}>
            {corpo}
          </Link>
        ) : (
          <div key={rotulo} className={classe}>
            {corpo}
          </div>
        );
      })}
    </div>
  );
}
